import { Typography } from '@/components';
import { TextStyles } from '@/constants';
import styled from 'styled-components';

export const OrderAmountWrapper = styled.div(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr auto',
  gap: theme.spacing[4],
}));

export const OrderAmountTitle = styled(Typography).attrs({
  variant: TextStyles['Heading 6'],
})<{ isBoldText?: boolean }>(({ theme, isBoldText }) => ({
  color: isBoldText ? theme.colors.highEmphasisBlack : theme.colors.inactiveBlack,
  textTransform: isBoldText ? 'uppercase' : 'inherit',
}));

export const OrderAmountValue = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
})<{ isBoldText?: boolean }>(({ theme, isBoldText }) => ({
  color: theme.colors.mediumEmphasisBlack,
  maxWidth: 120,
  textAlign: 'right',
  overflow: 'hidden',
  wordBreak: 'break-all',
  fontWeight: isBoldText ? theme.fontWeight.semiBold : 'inherit',
}));

export const DiscountWrapper = styled.div(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: theme.spacing[4],
}));
